import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';

// Import images
import jobs from "../../assets/images/jobs.png";
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import avatar2 from "../../assets/images/users/avatar-2.jpg";
import avatar3 from "../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../assets/images/users/avatar-4.jpg";

// Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from "swiper";
import 'swiper/swiper-bundle.min.css';

const CandidateSection = () => {
    const candidates = [
        {
            name: "Stephen Hadley",
            status: "Freelance",
            location: "Germany",
            avatar: avatar4,
        },
        {
            name: "Charles Brown",
            status: "Full Time",
            location: "Cambodia",
            avatar: avatar2,
        },
        {
            name: "Adam Miller",
            status: "Internship",
            location: "Australia",
            avatar: avatar1,
        },
        {
            name: "Keith Gonzales",
            status: "Freelance",
            location: "Belgium",
            avatar: avatar3,
        },
        {
            name: "Bonnie Harney",
            status: "Full Timer",
            location: "Syria",
            avatar: avatar4,
        },
        {
            name: "Dolores Minter",
            status: "Part Time",
            location: "San Marino",
            avatar: avatar2,
        },
    ];

    return (
        <React.Fragment>
            <Col lg={4}>
                <Card>
                    <CardBody>
                        <div className="d-flex">
                            <div>
                                <h4 className="card-title mb-3">Invite your friends to Skote</h4>
                                <p className="text-muted">
                                    Nor again is there anyone who loves or pursues or desires to obtain pain of itself, because it is pain, but because occasionally.
                                </p>
                                <div>
                                    <Link to="#" className="btn btn-primary btn-sm">
                                        <i className='bx bx-user-plus align-middle'></i> Invite Friends
                                    </Link>
                                </div>
                            </div>
                            <div>
                                <img src={jobs} alt="Jobs" height="130" />
                            </div>
                        </div>
                    </CardBody>
                </Card>
                
                <Card>
                    <CardBody>
                        <h4 className="card-title mb-3">Popular Candidates</h4>
                        <Swiper
                            modules={[Navigation, Pagination, Autoplay]}
                            spaceBetween={50}
                            slidesPerView={1}
                            navigation
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                        >
                            {candidates.map((candidate, index) => (
                                <SwiperSlide key={index}>
                                    <div className="bg-light p-3 d-flex mb-3 rounded">
                                        <img src={candidate.avatar} alt={candidate.name} className="avatar-sm rounded me-3" />
                                        <div className="flex-grow-1">
                                            <h5 className="font-size-15 mb-2">
                                                <a href="candidate-overview" className="text-body">
                                                    {candidate.name}
                                                </a> 
                                                <span className={`badge badge-soft-${candidate.status === 'Freelance' ? 'info' : candidate.status === 'Full Time' ? 'success' : 'warning'}`}>
                                                    {candidate.status}
                                                </span>
                                            </h5>
                                            <p className="mb-0 text-muted">
                                                <i className="bx bx-map text-body align-middle"></i> {candidate.location}
                                            </p>
                                        </div>
                                        <div>
                                            <UncontrolledDropdown>
                                                <DropdownToggle className="btn btn-soft-primary" type="button" id={`dropdownMenuButton${index}`}>
                                                    <i className='bx bx-dots-vertical-rounded'></i>
                                                </DropdownToggle>
                                                <DropdownMenu aria-labelledby={`dropdownMenuButton${index}`}>
                                                    <li><DropdownItem href="candidate-overview">View Details</DropdownItem></li>
                                                    <li><DropdownItem href="#">Download CV</DropdownItem></li>
                                                </DropdownMenu>
                                            </UncontrolledDropdown>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
};

export default CandidateSection;
